import React from 'react';
import { styled } from '@mui/system';
import { Link, useLocation } from 'react-router-dom';
import { List, ListItem, ListItemText, Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import * as MyStyles from "../styles/MyStyles";
import {GetRole} from "../logic/JwtExtractor";

const StyledList = styled(List)`
  background: linear-gradient(${MyStyles.Orange}, ${MyStyles.Black});
  color: ${MyStyles.White};
  width: 200px;
  position: fixed;
  top: 64px;
  bottom: 0;
  left: 0;
`;

const StyledListItem = styled(ListItem)`
  color: ${MyStyles.White};
  &:hover {
    background-color: ${MyStyles.BlackWithOpacity};
  }
  &.active {
    background-color: ${MyStyles.Black}; /* Set the color for active item */
  }
`;

const SubMenu = ({ primary, subItems }) => {
    const [open, setOpen] = React.useState(false);
    const location = useLocation();

    const handleToggle = () => {
        setOpen(!open);
    };

    const subItemStyle = {
        paddingLeft: '3rem', // Adjust the indentation as needed
    };

    return (
        <>
            <StyledListItem button onClick={handleToggle}>
                <ListItemText primary={primary} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </StyledListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {subItems.map((subItem) => (
                        <StyledListItem
                            key={subItem.to}
                            button
                            component={Link}
                            to={subItem.to}
                            className={location.pathname.includes(subItem.to) ? 'active' : ''}
                            style={subItemStyle}
                        >
                            <ListItemText primary={subItem.label} />
                        </StyledListItem>
                    ))}
                </List>
            </Collapse>
        </>
    );
};

const LeftAppMenu = () => {
    const location = useLocation();

    const menuItems = () => {
        let role = GetRole();

        if (role === 'Manager' || role === 'Admin') {
            return [
                {
                    primary: 'Dashboard',
                    to: '/',
                },
                {
                    primary: 'Contacts',
                    to: '/contacts',
                    subItems: [
                        { to: '/contacts/clients', label: 'Clients' },
                        //{ to: '/contacts/managers', label: 'Managers' },
                        //{ to: '/contacts/traders', label: 'Traders' },
                    ],
                },
                {
                    primary: 'Lookups',
                    to: '/lookups',
                    subItems: [
                        { to: '/lookups/assets', label: 'Assets' },
                        { to: '/lookups/countries', label: 'Countries' },
                        { to: '/lookups/nationalities', label: 'Nationalities' },
                        { to: '/lookups/banks', label: 'Banks' }
                    ],
                },
                {
                    primary: 'Newcent Accounts',
                    to: '/own-accounts',
                    subItems: [
                        { to: '/own-accounts/wallets', label: 'Wallets' },
                        { to: '/own-accounts/bank-accounts', label: 'Bank Accounts' }
                    ],
                },
                {
                    primary: 'Users',
                    to: '/users',
                },
                {
                    primary: 'Reporting',
                    to: '/reporting',
                },
                {
                    primary: 'Tickets',
                    to: '/tickets',
                },
            ];
        } else if (role === 'Trader') {
            return [];
        } else if (role === 'Client') {
            return [
                {
                    primary: 'Dashboard',
                    to: '/',
                },
                {
                    primary: 'Profile',
                    to: '/profile',
                },
                {
                    primary: 'Agreements',
                    to: '/agreements',
                },
                {
                    primary: 'Limits',
                    to: '/limits',
                },
                {
                    primary: 'Wallets',
                    to: '/wallets',
                },
                {
                    primary: 'Bank Accounts',
                    to: '/accounts',
                },
                {
                    primary: 'Transfers',
                    to: '/transfers',
                },
                {
                    primary: 'Orders',
                    to: '/orders',
                },
                {
                    primary: 'Trades',
                    to: '/trades',
                },
                {
                    primary: 'Files',
                    to: '/files',
                },
                {
                    primary: 'Reports',
                    to: '/reporting',
                },
                {
                    primary: 'Tickets',
                    to: '/tickets',
                },
            ];
        } else {
            throw new Error('Cant find menu items;');
        }
    }

    return (
        <StyledList component="nav">
            {menuItems().map((menuItem) =>
                menuItem.subItems ? (
                    <SubMenu key={menuItem.to} primary={menuItem.primary} subItems={menuItem.subItems} />
                ) : (
                    <StyledListItem
                        key={menuItem.to}
                        button
                        component={Link}
                        to={menuItem.to}
                        className={location.pathname === menuItem.to ? 'active' : ''}
                    >
                        <ListItemText primary={menuItem.primary} />
                    </StyledListItem>
                )
            )}
        </StyledList>
    );
};

export default LeftAppMenu;
